export const BUY_PICKUP_SUCCESS = 'BUY_PICKUP_SUCCESS';
export const BUY_PICKUP_REQUEST = 'BUY_PICKUP_REQUEST';
export const BUY_PICKUP_FAILURE = 'BUY_PICKUP_FAILURE';
export const BUY_PICKUP_REST = 'BUY_PICKUP_REST';
export const buyPickupSuccess = (payload) => ({
    type: BUY_PICKUP_SUCCESS,
    payload,
});
export const buyPickupRequest = (payload) => ({
    type: BUY_PICKUP_REQUEST,
    payload,
});
export const buyPickupFailure = (payload) => ({
    type: BUY_PICKUP_FAILURE,
    payload,
});
export const buyPickupRateRest = () => ({
    type: BUY_PICKUP_REST,
});
